// extracted by mini-css-extract-plugin
export default {"main":"layout_main__UZf-H","page":"layout_page__Xmr86","breadcrumb":"layout_breadcrumb__hbska"};